import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=22a98f4e&scoped=true&"
import script from "./payment.vue?vue&type=script&lang=ts&"
export * from "./payment.vue?vue&type=script&lang=ts&"
import style0 from "./payment.vue?vue&type=style&index=0&id=22a98f4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a98f4e",
  null
  
)

export default component.exports